const menuItems = [
  {
    title: 'Home',
    route: '/',
  },
  {
    title: 'Men',
    route: '/men',
    category: 'category-01',
  },
  {
    title: 'Women',
    route: '/women',
    category: 'category-02',
  },
  {
    title: 'Collections',
    route: '/collections',
  },
];

export default menuItems;
